import React from "react";
import { Box, Button, Modal, useToast } from "fds";
import "./index.scss";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import { nanoid } from "@reduxjs/toolkit";
import { t } from "i18next";
import useAdminContentStore from "../../redux/dispatcher/useAdminContentStore";
interface ConfirmDeleteOrRestoreModalProps {
  open: boolean;
  onClose: () => void;
  onClickAfter?: () => void;
  type: "delete" | "restore" | "adminDelete";
  syncIds: string[];
}
const ConfirmDeleteOrRestoreModal: React.FC<
  ConfirmDeleteOrRestoreModalProps
> = ({ open, onClose, onClickAfter, type, syncIds }) => {
  /** hook 모음 */
  const { getDocDeleteNow, getDocRestore } = useDocumentStore();
  const { deleteDocNow } = useAdminContentStore();
  const toasts = useToast();
  /** 함수 모음 */
  /** 삭제 또는 복원하는 함수 */
  const handleDocRestoreOrDeletePerm = async () => {
    if (type.toLocaleLowerCase().includes("delete")) {
      let resp: any = await (type === "adminDelete"
        ? deleteDocNow(syncIds)
        : getDocDeleteNow(syncIds));
      if (resp.payload) {
        toasts.toastMsg(nanoid(), t("trash.alert.deleteSuccess"), "success");
        onClickAfter && onClickAfter();
      } else {
        toasts.toastMsg(nanoid(), t("trash.alert.deleteFail"), "error");
      }
    } else {
      let resp = await getDocRestore(syncIds);
      if (resp.payload) {
        toasts.toastMsg(nanoid(), t("trash.alert.restoreSuccess"), "success");
        onClickAfter && onClickAfter();
      } else {
        toasts.toastMsg(nanoid(), t("trash.alert.restoreFail"), "error");
      }
    }
    onClose();
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      width={540}
      title={
        type === "restore" ? t("trash.restoreTitle") : t("trash.deleteTitle")
      }
      bodyMsg={
        type === "restore" ? t("trash.restoreDesc") : t("trash.deleteDesc")
      }
      footer={
        <Box>
          <Button
            btnStyle="fill"
            type="secondary"
            label={t("common.cancel")}
            onClick={onClose}
          />
          <Button
            btnStyle="fill"
            type={type === "restore" ? "primary" : "error"}
            state={type === "restore" ? "default" : "hover"}
            label={
              type === "restore"
                ? t("trash.action.restore")
                : t("trash.action.permDelete")
            }
            onClick={handleDocRestoreOrDeletePerm}
          />
        </Box>
      }
    />
  );
};
export default ConfirmDeleteOrRestoreModal;
